<template>
  <el-dialog
    :visible="visible"
    :width="isMobile ? '300px' : '775px'"
    append-to-body
    :close-on-click-modal="false"
    class="status-modal"
    @open="beforeOpen"
    @close="beforeClose"
  >
    <loader-wrapper v-if="showAutoList" :loading="loading || isLoading">
      <p style="color: #409eff">
        <b>Выберите авто :</b>
      </p>
      <el-table height="350" :data="automobile" style="width: 100%">
        <el-table-column label="Организация" prop="carrier_name">
          <template slot-scope="{ row }">
            <span v-if="row.carrier_name">{{ row.carrier_name }}</span>
            <span v-else style="font-size: 12px">Не указано</span>
          </template>
</el-table-column
        ><el-table-column label="Номер авто" prop="state_numbers">
          <template slot-scope="{ row }">
            <span v-if="row.state_numbers">{{ row.state_numbers }}</span>
            <span v-else style="font-size: 12px">Не указано</span>
          </template>
        </el-table-column>
        <el-table-column label="Номер прицепа" prop="state_numbers_trailer">
          <template slot-scope="{ row }">
            <span v-if="row.state_numbers_trailer">
              {{ row.state_numbers_trailer }}
            </span>
            <span v-else style="font-size: 12px">Не указано</span>
          </template>
        </el-table-column>
        <el-table-column align="right">
          <template slot="header" slot-scope="scope">
            <el-input
              v-model="search_automobile"
              size="mini"
              placeholder="Введите для поиска"
              :disabled="loading"
              @blur="filteredAutomobileList"
              @keyup.enter.native="filteredAutomobileList"
            />
          </template>
          <template slot-scope="scope">
            <span
              v-if="chosenAuto(scope.row)"
              style="display: flex; justify-content: flex-end"
            >
              <i class="el-icon-success date success" />
              <p class="date success">выбран</p>
            </span>
            <span v-else>
              <el-button
                v-if="isOwner(scope.row)"
                class="action-btn"
                size="mini"
                @click="handleSelect(scope.row)"
              >
                Выбрать
              </el-button>
              <el-button
                v-else
                class="action-btn"
                plain
                type="warning"
                size="mini"
                @click="handChangeOwner(scope.row)"
              >
                Привязать
              </el-button>
            </span>
          </template>
        </el-table-column>
      </el-table>
      <el-button
        style="margin-top: 24px; width: 100% !important"
        @click="showAutoList = false"
      >
        Создать авто
      </el-button>
    </loader-wrapper>

    <div v-else>
      <AutoAddInProgress
        :carrier-inn="innOrganization"
        :carrier-name="nameOrganization"
        @close="showAutoList = true"
      />
    </div>
  </el-dialog>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import AutoAddInProgress from '@/views/LoadDay/Modals/components/AutoAddInProgress'
import LoaderWrapper from '@/components/Shared/LoaderWrapper'

export default {
  name: 'AutomobileModalInProgress',
  components: { LoaderWrapper, AutoAddInProgress },
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    response: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      loading: false,
      showAutoList: true,
      selected_car: null,
      automobile_id: null,
      response_request_id: null,
      search_automobile: '',
      errorOrg: 'Организация не найдена',
    }
  },
  computed: {
    ...mapGetters({
      automobile: 'responseRequest/getAutomobile',
      getLoading: 'responseRequest/getLoading',
    }),
    innOrganization() {
      return this.response ? this.response.organization_inn : this.errorOrg
    },
    nameOrganization() {
      return this.response ? this.response?.organiztion_name : this.errorOrg
    },
    isLoading() {
      return this.loading || this.getLoading('Automobile')
    },
  },

  methods: {
    ...mapActions({
      getAutomobile: 'responseRequest/fetchAutomobileList',
      addAutomobile: 'responseRequest/addAutomobileToResponse',
      changeOwner: 'responseRequest/changeAutomobileOwner',
    }),
    chosenAuto(automobile) {
      return automobile && automobile?.id === this.response?.automobile_id
    },
    isOwner(row) {
      return Boolean(row?.user_id_match)
    },

    filteredAutomobileList() {
      this.getAutomobile({
        search: this.search_automobile,
        response_request_id: this.response.id,
      })
    },
    handleSelect(data) {
      const { id } = data

      this.addAutomobile({
        response_request_id: this.response.id,
        automobile_id: id,
      })
      this.beforeClose()
    },
    beforeOpen() {
      this.getAutomobile({ response_request_id: this.response.id })
    },
    beforeClose() {
      this.loading = false
      this.automobile_id = null
      this.search_automobile = ''
      this.$emit('close')
      this.showAutoList = true
    },
    handChangeOwner(auto) {
      this.changeOwner({
        response_request_id: this.response.id,
        automobile_id: auto.id,
      })
    },
  },
}
</script>

<style lang="sass">
.status-modal
  .row-wrap
    margin-bottom: 16px
  .action-btn
    min-width: 130px
  .set-date-wrap
    display: flex
    justify-content: flex-start
    align-items: center
    margin-top: 8px
    .el-date-editor
      min-width: 270px
  .el-dialog__body
    color: #000
    *
      font-family: 'Rubik', sans-serif
    .date-at
      color: #67C23A
      font-size: 16px
      font-weight: bold
      margin-top: 8px
      margin-bottom: 4px
    .resp-time
      font-size: 14px
      font-weight: normal
      color: #98A9BC
      margin: 4px 0px
      text-transform: lowercase
    span
      font-size: 16px
      text-transform: uppercase
    p
      font-size: 16px
      text-transform: uppercase
      margin-bottom: 0px
      margin-top: 0px
      &.first
        text-transform: uppercase
        margin: 0px 0px 0px 40px
    .el-timeline-item
    .el-timeline-item__content
      font-size: 14px
      font-weight: bold
      margin-top: 8px
      color: #000
      button
        margin-left: 10px
    .el-timeline-item__node
      border: 1px solid
    .el-timeline-item__timestamp
      margin-left: -30px
      margin-top: 8px!important
      font-size: 14px
      font-weight: normal
      color: #98A9BC
      margin: 0px
    .set-btn
      display: flex
      margin-left: 10px
</style>
